import styled from "styled-components";
import { getPropertyByMedia } from "../helpers";
export const StyledGrid = styled.section.attrs((props) => ({ style: props?.style, ...props })) `
	display: grid;
	grid-template-rows: min-content;

	${({ columns }) => getPropertyByMedia("grid-template-columns", columns, "auto")}
	${({ rows }) => getPropertyByMedia("grid-template-rows", rows, "auto")}
	${({ justifyContent }) => getPropertyByMedia("justify-content", justifyContent, "initial")}
	${({ alignItems }) => getPropertyByMedia("align-items", alignItems, "initial")}
	${({ maxWidth }) => getPropertyByMedia("max-width", maxWidth, "initial")}
	${({ gap }) => getPropertyByMedia("gap", gap, "16px")}
	${({ padding }) => getPropertyByMedia("padding", padding, "0px")}
	${({ margin }) => getPropertyByMedia("margin", margin, "0px")}
	${({ display }) => getPropertyByMedia("display", display, "grid")}
	${({ order }) => getPropertyByMedia("order", order)}

	width: 100%;
`;
//# sourceMappingURL=styles.js.map